import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { ReactionIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import { ReactionsPopover } from 'APP/components/ReactionsPopover/ReactionsPopover';

import styles from '../styles.m.css';

const Reactions = ({ message, popover }) => {
  const containerClasses = classNames(styles.itemContainer, {
    [styles.opened]: popover.isOpened,
  });

  return (
    <>
      <IconButton
        Icon={ReactionIcon}
        setRef={popover.containerRef}
        className={containerClasses}
        theme="chat-average"
        onMouseEnter={popover.mouseOver}
        onMouseLeave={popover.mouseOut}
      />
      {popover.isOpened && (
        <ReactionsPopover
          message={message}
          reference={popover.containerRef.current}
          onMouseEnter={popover.mouseOver}
          onMouseLeave={popover.mouseOut}
          onClose={popover.close}
        />
      )}
    </>
  );
};

export default observer(Reactions);
